// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2afK8","col":"styles_col__1TQLV"};